export const BUTTON_LINK_TO_ENTRY_PAGE = '/order-tracker';
export const BUTTON_TEXT = 'Track another order';
export const TRACK_ANOTHER_ORDER_ANALYTICS = 'Track another order';
export const CVE_GUIDE_LABEL = 'Guide to Cloud Voice Express';
export const CVE_GUIDE_URL =
  'https://business.bt.com/help/guides/getting-started-with-your-bt-business-products/using-your-cloud-voice-express-phone-service/';
export const CVE_APP_LABEL = 'Download Cloud Voice Express app';
export const CVE_APP_URL = 'https://business.bt.com/comms/cloud-voice-express-app/ ';
